import { Loader } from '@unistocks/components/loading/spinner/loader';
import { Header } from '@unistocks/features/navigation/header';
import { NavSidebar } from '@unistocks/features/navigation/sidebar';
import { usePrefetchUserQueries } from '@unistocks/shared/hooks/use-prefetch-queries';
import { Navigator, Slot } from 'expo-router';
import React from 'react';

export default function TabLayout() {
  usePrefetchUserQueries();

  return (
    <Navigator>
      <Header />
      <NavSidebar />
      <React.Suspense fallback={<Loader />}>
        <Slot />
      </React.Suspense>
    </Navigator>
  );
}
